module.exports = __webpack_public_path__ + "img/talksport-2.a1084e45.png";